import { A } from "components/A";
import { Devoxx4Kids } from "components/Images/Devoxx4Kids";
import SEO from "components/seo";
import { OGImage } from "components/OG";
import { Heading, Text, Box, Stack, List, ListItem, Divider, Flex } from "@chakra-ui/core";
import RedirectCodeursEnSeine from "components/RedirectCodeursEnSeine";
import * as React from 'react';
export default {
  A,
  Devoxx4Kids,
  SEO,
  OGImage,
  Heading,
  Text,
  Box,
  Stack,
  List,
  ListItem,
  Divider,
  Flex,
  RedirectCodeursEnSeine,
  React
};